export default __webpack_public_path__ + "static/1984-04-06_ColumbiaVareseSymposium.pdf";